<template>
    <div id="planningadmin">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="openNav()" src="/assets/burger.png" alt="burger" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
            <div class="sideNav" :style="{ width: navWidth + 'px' }">
                <div class="leftNav">
                    <div class="innerNav">
                        <img class="navLogout" v-on:click="openNav()" src="/assets/burgerwhite.png" alt="burger" />
                    </div>
                </div>
                <div v-if="navMenuVisible" class="navsidecontent">
                    <div class="navtitle noborder">
                        Gérer les biens et demandes
                    </div>
                    <div v-on:click="goToNewBuildingPage" class="navsubtitle">
                        Créer un nouveau bien
                    </div>
                    <div v-on:click="goToBuildingPage" class="navsubtitle">
                        Consulter/Modifier les biens et demandes
                    </div>
                    <div class="navtitle">
                        Plannings
                    </div>
                    <div v-on:click="refresh" class="navsubtitle">
                        Consulter/Modifier les plannings
                    </div>
                    <div v-on:click="goToTimeSheetPage" class="navsubtitle">
                        Fiches horaires
                    </div>
                    <div class="navtitle">
                        Groupes
                    </div>
                    <div v-on:click="goToNewGroupPage" class="navsubtitle">
                        Ajouter un groupe
                    </div>
                    <div v-on:click="goToAllGroupPage" class="navsubtitle">
                        Voir/Modifier les groupes
                    </div>
                    <div class="navtitle">
                        Utilisateurs
                    </div>
                    <div v-on:click="goToNewUserPage" class="navsubtitle">
                        Ajouter un utilisateur
                    </div>
                    <div v-on:click="goToAllUserPage" class="navsubtitle">
                        Voir/Modifier les utilisateurs
                    </div>
                    <div v-on:click="logout()" class="navtitle logout">
                        Déconnexion
                    </div>
                </div>
            </div>
        </nav>
        <div class="outercircle">
            <div class="homeName">
                {{Name}}
            </div>
            <div id="circle"></div>
        </div>
        <h1>
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
            {{ title }}
        </h1>
        <div id='calendar'>
            <FullCalendar   class="calendar"
                            ref="fullcalendar"
                            @dateClick="handleDateClick"
                            @eventClick="eventClick"
                            :themeSystem='themeCal'
                            schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
                            timeZone="Europe/Paris" 
                            defaultView="resourceTimelineDay" 
                            resourceLabelText="Techniciens"
                            locale='fr'
                            minTime='05:00:00'
                            maxTime='20:00:00'
                            resourceAreaWidth='135px'
                            :weekends="false"
                            :slotDuration='slotDuration()'
                            :buttonText="btnTxt"
                            :selectable="calSelect"
                            :nowIndicator="calNow"
                            :editable="calEdit"
                            :plugins="calendarPlugins"
                            :header="calHeader"
                            :resources="calResources"
                            :events="calEvents"
                            :datesRender="datesRender"
            />
       </div>
            
        <modal height="250px" name="planningdetails">
            <div class="modalDiv">
                <div class="txtDiv">
                    <span class="modalTxt">{{ModalType}}</span>
                </div>    
                <div class="txtDiv">
                    <span class="modalTxt">{{ModalAddress}}</span>
                </div>    
                <button class="docBtn3" type="button" v-on:click="goToIntervention()">Voir l'intervention</button><br><br>
                <button class="docBtn3" type="button" v-on:click="closeModal">OK</button>   
            </div>    
        </modal>
    </div>
</template>

<script>
    import axios from 'axios';
    import FullCalendar from '@fullcalendar/vue'
    import interactionPlugin from '@fullcalendar/interaction'
    import resourceCommonPlugin from '@fullcalendar/resource-common'
    import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
    import timegridPluginRes from '@fullcalendar/resource-timegrid'
    import daygridPluginRes from '@fullcalendar/resource-daygrid'
    import timegridPlugin from '@fullcalendar/timegrid'
    import daygridPlugin from '@fullcalendar/daygrid'
    import bootstrapPlugin from '@fullcalendar/bootstrap'
    import timelinePlugin from '@fullcalendar/timeline'
    import listPlugin from '@fullcalendar/list'
    import luxonPlugin from '@fullcalendar/luxon'
    import momentPlugin from '@fullcalendar/moment'
    import momentTZPlugin from '@fullcalendar/moment-timezone'

    export default {
        name: 'Planningadmin',
        components: {
            FullCalendar
        },
        data (){
            return {
                btnTxt:{
                  today:    "Revenir à Aujourd'hui",
                  month:    'mois',
                  week:     'semaine',
                  day:      'jour',
                  list:     'liste'
                },
                calendarPlugins: [
                                    interactionPlugin,
                                    resourceTimelinePlugin,
                                    timegridPlugin,
                                    daygridPlugin,
                                    timegridPluginRes, 
                                    daygridPluginRes, 
                                    bootstrapPlugin, 
                                    timelinePlugin,
                                    listPlugin,
                                    resourceCommonPlugin,
                                    luxonPlugin,
                                    momentPlugin,
                                    momentTZPlugin
                                 ],
                calRatio:1.5,
                calEvents:[],
                calResources:[],
                calEdit:false,
                calSelect:true,
                calNow:true,
                color2:["DarkOrange","MediumAquaMarine","MediumSpringGreen","SlateBlue","MediumTurquoise","Chocolate","PaleVioletRed","SaddleBrown","Orchid","DarkGreen","Orange","Plum","ForestGreen","OliveDrab","DarkSalmon","Teal","Cyan","DarkOrchid","LawnGreen","RebeccaPurple","GreenYellow","IndianRed","HotPink","Turquoise","DarkCyan","DarkKhaki","DarkMagenta","Aquamarine","DarkViolet","CornflowerBlue","DarkOliveGreen","DeepSkyBlue","BlueViolet","Thistle","Linen","Gold","Bisque","DodgerBlue","Purple","RosyBrown","Red","Magenta","YellowGreen","LemonChiffon","Chartreuse","Wheat","Gainsboro","MediumVioletRed","LimeGreen","BurlyWood","LavenderBlush","CadetBlue","Peru","SeaGreen","MistyRose","DarkBlue","DarkTurquoise","Brown","DarkRed","DarkSeaGreen","Violet","Maroon","Yellow","Crimson","Pink","SpringGreen","MediumOrchid","Fuchsia","SteelBlue","DarkGoldenRod","GoldenRod","RoyalBlue","PeachPuff","MediumPurple","PaleGoldenRod","Olive","MediumSlateBlue","Khaki","Indigo","AntiqueWhite","Blue","SkyBlue","DeepPink","Lavender","Sienna","Silver","PaleTurquoise","OrangeRed","Moccasin","Coral","FireBrick","Salmon","MediumBlue","MediumSeaGreen","SandyBrown","Tomato","Aqua","Lime","Green","Tan","PaleGreen","PowderBlue"],
                color3:["#339933","#99334d","#33ff99","#993366","#669933","#ccff33","#33ffcc","#4d9933","#ffcc33","#336699","#9933ff","#809933","#3333ff","#4d3399","#ffff33","#33ff33","#994d33","#334d99","#803399","#cc33ff","#3399ff","#6633ff","#ff3366","#33994d","#339980","#ff3333","#ff9933","#33ffff","#3366ff","#99ff33","#663399","#33ccff","#ff6633","#996633","#ff3399","#ff3333","#999933","#338099","#993333","#66ff33","#ff33ff","#33ff66","#333399","#998033","#993333","#993380","#ff33cc","#339999","#339966","#993399"],
                color5:["#99ff33","#ff9933","#334d99","#ff3399","#339999","#994d33","#663399","#ff3333","#ffcc33","#33ff99","#4d3399","#4d9933","#33ff33","#339933","#669933","#ff33ff","#6633ff","#ff33cc","#339966","#99334d","#ff3333","#9933ff","#33ffcc","#ff3366","#993380","#993333","#3399ff","#66ff33","#33994d","#809933","#333399","#996633","#998033","#33ffff","#3333ff","#339980","#ff6633","#993399","#33ff66","#993333","#ccff33","#999933","#993366","#cc33ff","#803399","#33ccff","#338099","#3366ff","#ffff33","#336699"],
                color4:["Red","Yellow","Cyan","Blue","Magenta","Green","Pink","Purple","Salmon","Orange","Lime","Olive","SaddleBrown","Maroon","RebeccaPurple","OrangeRed","Gold","DarkKhaki","RosyBrown","DarkGoldenRod","Peru","Tan","Indigo","Teal","Gray","Black"],
                color:["Gold","Orange","Lime","DodgerBlue","Indigo","Red","Magenta","RosyBrown","Pink","DarkKhaki","Cyan","DarkGoldenRod","Purple","Yellow","RebeccaPurple","Salmon","Green","Teal","OrangeRed","Blue","SaddleBrown","Maroon","Tan","Peru","Olive","Gray","Black"],
                themeCal:'Materia',
                calHeader: {
                          left: 'prev, next, resourceTimelineDay, resourceTimelineWeek, resourceTimelineMonth',
                          center: 'title',
                          right: "today"
                        },
                Name:"ADPR",
                ModalType: "Type d'intervention inconnue",
                ModalAddress: "Adresse de l'intervention inconnue",
                ModalIntervention: "x",
                users: [],
                plannings: [],
                navWidth:0,
                navMenuVisible:false,
                isYearHide: [],
                title: "Planning",
                activeStart: new Date()/1000 |0,
                activeEnd: new Date()/1000 |0
            };
        },
        methods:{
            slotDuration(){
                if(this.activeEnd - this.activeStart === 604800 || this.activeEnd - this.activeStart ===  432000){
                    return '03:00:00';
                }
                else{
                    return '00:30:00';
                }
            },
            datesRender(info){
                this.activeStart = (new Date(info.view.activeStart) /1000 | 0);
                this.activeEnd = (new Date(info.view.activeEnd) /1000 | 0);
                this.getCalendar(this.activeStart, this.activeEnd);
            },
            backbtn(){

                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);
                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);
                
                this.$cookie.set('history', JSON.stringify(arrHist.slice(0, -1)));
                this.$cookie.set('historyQuery', JSON.stringify(arrQuery.slice(0, -1)));

                if(arrHist.length){
                    if(arrQuery[arrQuery.length-1] !== "" && arrQuery[arrQuery.length-1] !== "undefined"){
                        this.$router.replace({ name: arrHist[arrHist.length-1], query: {name: arrQuery[arrQuery.length-1]} });
                    }
                    else{
                        this.$router.replace({ name: arrHist[arrHist.length-1] });
                    }
                }
                else{
                    this.$cookie.set('currentAriane', "");
                    this.$router.replace({ name: "adminhome" });
                }
            },
            handleDateClick(data){
                console.log(data.dateStr)
                console.log(data.resource.id)
            },
            eventClick(data){
                this.ModalType = data.event.title;

                if(this.plannings[parseInt(data.event.id)].addressStr){
                    this.ModalAddress = this.plannings[parseInt(data.event.id)].addressStr;
                }
                else{
                    this.ModalAddress = "Adresse de l'intervention inconnue"
                }

                this.openModal();
                this.getInterventionId(this.ModalType, this.plannings[parseInt(data.event.id)].user.idWeweb, this.plannings[parseInt(data.event.id)].startTimestamp, this.plannings[parseInt(data.event.id)].endTimestamp)
            },
            async getInterventionId(title, idWeweb, start, end){
                var response = await axios.get('https://so.gaviota.fr/api/building/intervention/planning/'+idWeweb+"/"+start+"/"+end+"/"+title);
                if(response.data.intervention._id){
                    this.ModalIntervention = response.data.intervention._id;
                }
            },
            getFullAddress(a){
                return "&nbsp;&nbsp;" + a.firstName + "&nbsp;&nbsp;" + a.lastName + "<br>" + a.streetNb + "&nbsp;&nbsp;" + a.streetName + "&nbsp;&nbsp;" + a.postalCode + "&nbsp;&nbsp;" + a.city + "<br>" + a.phoneNumber + "&nbsp;&nbsp;-&nbsp;&nbsp;" + a.emailAddress;
            },
            refresh(){
                location.reload();
            },
            goToIntervention(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "interventionadmin", query: {name: this.ModalIntervention}});
            },
            goToBuildingIngListPage(){

                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "buildinginqlist", query: {name: this.$route.query.name}});
            },	
            goToBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "buildinglist"});
            },
            goToNewBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newbuilding"});
            },
            goToPlanningPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "planningadmin"});
            },
            goToTimeSheetPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "timesheet"});
            },
            goToAllUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "alluser"});
            },
            goToNewUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newuser"});
            },
            goToAllGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "allgroup"});
            },
            goToNewGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newgroup"});
            },
            openModal(){
                this.$modal.show('planningdetails');
            },
            closeModal(){
                this.$modal.hide('planningdetails');
            },
            openNav(){
                 
                if(!this.navWidth){
                    this.navWidth = 300;
                }
                else{
                    this.navWidth = 0;
                }
                
                var vm = this;
                setTimeout(function(){
                    vm.navMenuVisible = !vm.navMenuVisible;
                }, 100);
            },
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('historyQuery');
                this.$cookie.delete('history');
                this.$router.replace({ name: "login" });
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$cookie.set('history', "");
                this.$cookie.set('historyQuery', "");
                this.$router.replace({ name: "adminhome" });
            },
            getCookies: function() {
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || (this.$cookie.get('role') !== "admin" && this.$cookie.get('role') !== "technicien bureau") ){
                    this.$router.replace({ name: "login" });
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    this.getUserName();
                }
            },
            async getUserName(){
                    
                var response = await axios.get('https://so.gaviota.fr/api/userdata/admin/all');
                if(response.data.users){
                    this.users = response.data.users;
                    for(var o=0; o<this.users.length; o++){
                        this.calResources.push({
                                                id:this.users[o].idWeweb,
                                                title:this.users[o].address.firstName + " " + this.users[o].address.lastName,
                                                eventColor:this.color[o]
                                                }) 
                    }         
                }
                let calendarApi = this.$refs.fullcalendar.getApi();
                calendarApi.updateSize();
            },
            async getCalendar(start, end){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/building/planning/'+start+"/"+end);
                if(response.data.plannings){
                    this.plannings = response.data.plannings;
                    this.calEvents = [];
                    for(var o=0; o<this.plannings.length; o++){
                        this.calEvents.push({
                                                resourceId:this.plannings[o].user.idWeweb,
                                                title:this.plannings[o].activityType,
                                                start:new Date(this.plannings[o].startTimestamp*1000),
                                                end:new Date(this.plannings[o].endTimestamp*1000),
                                                id:o
                                            });
                    }         
                }
                
                let calendarApi = this.$refs.fullcalendar.getApi();
                calendarApi.updateSize();
                            
            }
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');

    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/resource-timeline/main.css';
    @import '~@fullcalendar/timeline/main.css';
    @import '~@fullcalendar/list/main.css';

    #planningadmin {
        width: 90%;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 60px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
        position:relative;
    }
    @media screen and (max-width: 768px) {
        .h1 {
              font-size: 24px;
            }
    }
    h2{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding:15px;
        font-size: 24px;
        font-weight: 600;
        display: block;
        border-bottom: 2px solid #1ce83e6e;
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:11;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }

    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }

    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
    
    .btn{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        display: block;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        display: inline;
    }
    .left{
        float:left;
    }
    .right{
        float:right;
    }
    .imgCard{
        width:100%;
        height: 200px;
        object-fit: cover;
    }
    .btnCard{
        width:20px;
        height: 20px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 20px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    #circleRed {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #ff0000;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 60px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .divCard{
        vertical-align: middle;
        position: relative;
        background-color: #F0F0F0;
        border-bottom: 2px solid;
        border-color:#1ce83e28;
        padding:10px;
        margin:2px;
    }
    .spanCard{
        display:inline-block;
        padding-left:5px;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 17px;
    }
    @media screen and (max-width: 768px) {
        .spanCard {
              font-size: 14px;
            }
    }
   .btnAccordion{
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
        border:none;
        cursor: pointer;
        width: calc(100% - (5px + 5px));
        display: inline-block;
        text-align: left;
        background-color: #FFF;
        margin: 5px;
    }
    .btnAccordionNone{
        cursor: default;
        padding-left:15px;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        text-align: left;
        background-color: #1ce83e;
        font-size: 30px;
        position: absolute;
        left: 1%;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .notifList{
        margin-bottom: 10px;
    }
    .container{
        padding: 20px;
        font-size: 17px;
        font-family: 'BenchNine', sans-serif;
        -webkit-column-count: 2; /* Old Chrome, Safari and Opera */
        -moz-column-count: 2; /* Old Firefox */
        column-count: 2;
    }
    .btnContainer{
        height: 30px;
        padding:20px;
        background-color: #FFF;
        margin-bottom: 20px;
        position: relative;
    }
    hr{
        margin-bottom: 0px;
        border-color: rgba(240, 240, 240, 0.3);
        color: rgba(240, 240, 240, 0.3);
    }	
    .sideNav{
        background-clip: border-box;
        background-color: #FFF;
        background-origin: padding-box;
        box-sizing: border-box;
        background-color: #333;
        display: block;
        height: 100%;
        overflow:auto;
        box-shadow: 8px 0px 6px -6px #999;
        position:fixed;
        top:0;
        left:0;
        z-index:10;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navsidecontent{
        color:white;
        font-family: 'BenchNine', sans-serif;
        margin-top:65px;
        margin-left:30px;
        margin-right:30px;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navtitle{
        margin:10px;
        margin-top:15px;
        padding-top:5px;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        border-top: 1px solid;
        border-color:#eee;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:default;
                              
    }
    .navsubtitle{
        margin:7px;
        font-size: 18px;
        font-weight: 400;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:pointer;
    }
    .navsubtitle:hover{
        color:#999;
    }
    .noborder{
        border:none;
        margin-top:5px;
        padding-top:0px;
    }
    .logout{
        padding-top:50px;
        cursor:pointer;
    }
    .textline{
        padding:5px;
    }
    
	/* width */
	::-webkit-scrollbar {
		width: 6px;
	}
	
	/* Track */
	::-webkit-scrollbar-track {
		background: #ddd; 
	}
	
	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #888; 
		border-radius: 3px;
	}
	
	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}
    .editBtn{
        width:30px;
        height: 30px;
        position:absolute;
        bottom:20px;
        right:20px;
        cursor:pointer;
    }
    .calendar{
        font-family: 'BenchNine', sans-serif;
        font-size: 14px;
        margin: 40px auto;
    }
    .modalDiv{
        margin:30px;
        text-align: center;
    }
    .modalAmount{
        width:100px;
        margin:auto;
    }
    .modalTxt{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
    }
    .txtDiv{
        margin-bottom: 15px; 
    }
    .modalNotes{
        background-color: #F0F0F0;
        resize: none;
        width:80%;
    }
    .docBtn3{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: inline-block;
        border:none;
        color:#1ce83e;
        font-size: 18px;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        width: 200px;
    }
</style>